export const fallingSkiesQuest = {
    id: 'falling_skies',
    titleKey: 'chapter_falling_skies',
    shortName: 'SKIES',
    date: '15.01.2026',
    status: 'locked',
    questMap: [
        {
            id: 'step_start_scout',
            label: {
                en: "Locate the fallen plane",
                tr: "Düşen uçağı bul",
                ru: "Найти упавший самолёт"
            },
            type: 'start',
            isSubTask: false,
            details: {
                location: { en: "Woods", tr: "Ormanlık", ru: "Лес" },
                objective: {
                    en: "Locate the crashed plane in Woods.",
                    tr: "Ormanlık haritasındaki düşen uçağı bul.",
                    ru: "Найдите упавший самолёт в Лесу."
                },
                story: {
                    en: "\"Mechanic and I got to talking about that plane that went down somewhere in the nature reserve. Nobody really knows what happened to it. I should track it down and take a look — maybe I'll find something interesting.\"",
                    tr: "\"Mechanic ile doğa koruma alanının bir yerine düşen şu uçak hakkında konuştuk. Kimse ona ne olduğunu tam olarak bilmiyor. İzini sürüp bir bakmalıyım — belki ilginç bir şeyler bulurum.\"",
                    ru: "\"Мы с Механиком разговорились о том самолёте, который упал где-то в заповеднике. Никто толком не знает, что с ним случилось. Надо бы его разыскать и взглянуть — может, найду что-нибудь интересное.\""
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to Woods. Navigate to the large mountain/rock area near the center-south.",
                            tr: "Ormanlık haritasına git. Haritanın orta-güney kısmındaki büyük kaya/dağlık alana ilerle.",
                            ru: "Идите в Лес. Направляйтесь к большой горе/скале в центрально-южной части карты."
                        },
                        images: ['/Story/FallingSkies/Step1-Map.webp', '/Story/FallingSkies/Step1-PlaneView.webp']
                    },
                    {
                        text: {
                            en: "Approach the crashed plane to trigger the objective completion.",
                            tr: "Görevi tamamlamak için düşen uçağa yaklaş.",
                            ru: "Подойдите к разбившемуся самолёту, чтобы выполнить задачу."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_gather_intel',
            label: {
                en: "Gather Intel from Traders",
                tr: "Satıcılardan istihbarat topla",
                ru: "Собрать разведданные у торговцев"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Menu / Traders", tr: "Menü / Satıcılar", ru: "Меню / Торговцы" },
                objective: {
                    en: "Reach LL2 with Prapor and gather info from Traders.",
                    tr: "Prapor ile Sadakat Seviyesi 2'ye ulaş ve satıcılardan bilgi topla.",
                    ru: "Достигните 2-го уровня лояльности с Прапором и соберите информацию у торговцев."
                },
                warning: {
                    en: "Requirement: You must be Loyalty Level 2 with Prapor to proceed!",
                    tr: "Gereksinim: Devam etmek için Prapor ile Sadakat Seviyesi (LL) 2 olmalısın!",
                    ru: "Требование: Для продолжения необходим 2-й уровень лояльности у Прапора!"
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to Traders menu. Talk to Prapor, Therapist, Skier, Mechanic, and Jaeger regarding the plane.",
                            tr: "Satıcılar menüsüne git. Uçak hakkında Prapor, Therapist, Skier, Mechanic ve Jaeger ile konuş.",
                            ru: "Зайдите в меню торговцев. Поговорите с Прапором, Терапевтом, Лыжником, Механиком и Егерем о самолёте."
                        }
                    },
                    {
                        text: {
                            en: "Optional: Pay Therapist $2,000 for the G-Wagon location clue.",
                            tr: "İsteğe bağlı: G-Wagon konumu ipucu için Therapist'e 2.000$ öde.",
                            ru: "Необязательно: Заплатите Терапевту 2 000$ за подсказку о местонахождении G-Wagon."
                        },
                        images: ['/Story/FallingSkies/Step2-Therapist.webp']
                    }
                ]
            }
        },
        {
            id: 'step_gwagon_drive',
            label: {
                en: "Retrieve the G-Wagon Flash Drive",
                tr: "G-Wagon'daki flash belleği al",
                ru: "Забрать флешку из G-Wagon"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Shoreline", tr: "Kıyı Şeridi", ru: "Берег" },
                objective: {
                    en: "Find the black G-Wagon and retrieve the Flash Drive.",
                    tr: "Siyah G-Wagon'u bul ve flash belleği al.",
                    ru: "Найдите чёрный G-Wagon и заберите флешку."
                },
                story: {
                    en: "\"Therapist pointed me to the coast. A convoy escorting the cargo was hit. There's a black G-Wagon near the tunnel extraction. One of the guards might have secured the data.\"",
                    tr: "\"Therapist sahili işaret etti. Kargo konvoyu vurulmuş. Tünel çıkışının yakınında siyah bir G-Wagon var. Korumalardan biri veriyi güvenceye almış olabilir.\"",
                    ru: "\"Терапевт указала на побережье. Конвой, сопровождавший груз, был атакован. У выхода «Тоннель» стоит чёрный G-Wagon. Один из охранников мог сохранить данные.\""
                },
                requiredItems: [
                    { en: "G-Wagon Flash Drive (In-Raid)", tr: "G-Wagon Flash Belleği (Raid İçi)", ru: "Флешка из G-Wagon (в рейде)" }
                ],
                guideSteps: [
                    {
                        text: {
                            en: "Go to Shoreline. Head towards the 'Tunnel' extract.",
                            tr: "Kıyı Şeridi haritasına git. 'Tünel' (Tunnel) çıkışına doğru ilerle.",
                            ru: "Идите на Берег. Направляйтесь к выходу «Тоннель»."
                        },
                        images: ['/Story/FallingSkies/Step3-Map.webp']
                    },
                    {
                        text: {
                            en: "Locate the black SUV (Mercedes G-Class) near the exfiltration trucks.",
                            tr: "Çıkış kamyonlarının yanındaki siyah SUV'u (Mercedes G-Serisi) bul.",
                            ru: "Найдите чёрный внедорожник (Mercedes G-Class) рядом с грузовиками эвакуации."
                        },
                        images: ['/Story/FallingSkies/Step3-SUV.webp']
                    },
                    {
                        text: {
                            en: "Check the driver's side floor mat for the Flash Drive. Take it and Extract.",
                            tr: "Sürücü tarafı paspasının altındaki flash belleği kontrol et. Al ve çıkış yap.",
                            ru: "Проверьте коврик со стороны водителя на наличие флешки. Заберите её и эвакуируйтесь."
                        }
                    }
                ]
            }
        },
        {
            id: 'step_blackbox_stash',
            label: {
                en: "Retrieve and Stash the Flight Recorder",
                tr: "Uçuş kayıt cihazını al ve sakla",
                ru: "Забрать и спрятать бортовой самописец"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Woods -> Shoreline", tr: "Ormanlık -> Kıyı Şeridi", ru: "Лес -> Берег" },
                objective: {
                    en: "Get Flight Recorder from Woods, then Stash it on Shoreline.",
                    tr: "Ormanlık'tan Uçuş Kayıt Cihazını al, ardından Kıyı Şeridi'nde sakla.",
                    ru: "Заберите бортовой самописец из Леса, затем спрячьте его на Берегу."
                },
                warning: {
                    en: "This is a two-part step! You must survive Woods with the item first.",
                    tr: "Bu iki aşamalı bir adımdır! Önce eşya ile Ormanlık'tan sağ çıkmalısın.",
                    ru: "Это двухэтапный шаг! Сначала вы должны выжить в Лесу с предметом."
                },
                guideSteps: [
                    {
                        text: {
                            en: "PART 1: Go back to the plane in Woods. Find the Orange Flight Recorder in the tail section breach.",
                            tr: "KISIM 1: Ormanlık'taki uçağa geri dön. Kuyruk kısmındaki yırtıkta Turuncu Uçuş Kayıt Cihazını (Kara Kutu) bul.",
                            ru: "ЧАСТЬ 1: Вернитесь к самолёту в Лесу. Найдите оранжевый бортовой самописец в разломе хвостовой части."
                        },
                        images: ['/Story/FallingSkies/Step4-RecorderLoc.webp']
                    },
                    {
                        text: {
                            en: "PART 2: Go to Shoreline -> Scav Island (Fisher's Island).",
                            tr: "KISIM 2: Kıyı Şeridi'ne git -> Scav Adası (Balıkçı Adası).",
                            ru: "ЧАСТЬ 2: Идите на Берег -> Остров Диких (Рыбацкий остров)."
                        },
                        images: ['/Story/FallingSkies/Step4-IslandMap.webp']
                    },
                    {
                        text: {
                            en: "Find the wooden house on the island. Stash the recorder inside the dilapidated room.",
                            tr: "Adadaki ahşap evi bul. Kayıt cihazını yıkık dökük odanın içine sakla (Stash et).",
                            ru: "Найдите деревянный дом на острове. Спрячьте самописец внутри полуразрушенной комнаты."
                        },
                        images: ['/Story/FallingSkies/Step4-StashSpot.webp']
                    }
                ]
            }
        },
        {
            id: 'step_chairman_house',
            label: {
                en: "Investigate the Chairman's House",
                tr: "Başkan'ın Evini araştır",
                ru: "Обыскать дом председателя"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Shoreline", tr: "Kıyı Şeridi", ru: "Берег" },
                objective: {
                    en: "Retrieve Transcript and Elektronik's Drive from Chairman's House.",
                    tr: "Başkan'ın Evi'nden Transkripti ve Elektronik'in flash belleğini al.",
                    ru: "Заберите стенограмму и флешку Электроника из дома председателя."
                },
                story: {
                    en: "\"The decrypted data mentions a meeting point in the village. The 'Chairman's House'. They were coordinating something big. I need that transcript.\"",
                    tr: "\"Şifresi çözülen veriler köyde bir buluşma noktasından bahsediyor. 'Başkan'ın Evi'. Büyük bir şeyi koordine ediyorlarmış. O dökümana ihtiyacım var.\"",
                    ru: "\"В расшифрованных данных упоминается место встречи в деревне. «Дом председателя». Они координировали что-то крупное. Мне нужна эта стенограмма.\""
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go to Shoreline Village. Locate the Chairman's House (North side of village).",
                            tr: "Kıyı Şeridi Köyü'ne git. Başkan'ın Evi'ni bul (Köyün kuzey tarafı).",
                            ru: "Идите в деревню на Берегу. Найдите дом председателя (северная часть деревни)."
                        },
                        images: ['/Story/FallingSkies/Step5-HouseExt.webp']
                    },
                    {
                        text: {
                            en: "Item 1: 'Plane Crew Transcript' is under the overturned mattress.",
                            tr: "Eşya 1: 'Uçak Mürettebatı Transkripti' ters dönmüş yatağın altındadır.",
                            ru: "Предмет 1: «Стенограмма экипажа самолёта» находится под перевёрнутым матрасом."
                        },
                        images: ['/Story/FallingSkies/Step5-Item1.webp']
                    },
                    {
                        text: {
                            en: "Item 2: 'Elektronik's Flash Drive' is on the nightstand inside a broken plate.",
                            tr: "Eşya 2: 'Elektronik'in Flash Belleği' komodinin üzerindeki kırık tabağın içindedir.",
                            ru: "Предмет 2: «Флешка Электроника» находится на тумбочке в разбитой тарелке."
                        },
                        images: ['/Story/FallingSkies/Step5-Item2.webp']
                    }
                ]
            }
        },
        {
            id: 'step_armored_case',
            label: {
                en: "The Final Choice: Armored Case",
                tr: "Son Seçim: Zırhlı Çanta",
                ru: "Финальный выбор: Бронированный кейс"
            },
            type: 'objective',
            isSubTask: false,
            details: {
                location: { en: "Woods", tr: "Ormanlık", ru: "Лес" },
                objective: {
                    en: "Retrieve the Armored Case and make your choice.",
                    tr: "Zırhlı Çantayı al ve seçimini yap.",
                    ru: "Заберите Бронированный кейс и сделайте свой выбор."
                },
                warning: {
                    en: "CRITICAL CHOICE: Handing over to Prapor or Keeping it affects future quests!",
                    tr: "KRİTİK SEÇİM: Prapor'a vermek veya kendine saklamak gelecek görevleri etkiler!",
                    ru: "ВАЖНЫЙ ВЫБОР: Передача Прапору или сохранение кейса влияет на будущие квесты!"
                },
                story: {
                    en: "\"Mechanic calls it 'The Ticket Out of Tarkov'. Prapor wants it to settle debts. But if the rumors are true, this case holds the key to freedom. Do I remain loyal, or do I take the chance?\"",
                    tr: "\"Mechanic buna 'Tarkov'dan Çıkış Bileti' diyor. Prapor borçlarını kapatmak için istiyor. Ama söylentiler doğruysa, bu çanta özgürlüğün anahtarını taşıyor. Sadık mı kalmalıyım, yoksa şansımı mı denemeliyim?\"",
                    ru: "\"Механик называет это «Билетом из Таркова». Прапору он нужен, чтобы расплатиться с долгами. Но если слухи верны, в этом кейсе ключ к свободе. Остаться верным или рискнуть?\""
                },
                guideSteps: [
                    {
                        text: {
                            en: "Go back to the Plane in Woods. Enter the cockpit.",
                            tr: "Ormanlık'taki uçağa geri dön. Kokpite gir.",
                            ru: "Вернитесь к самолёту в Лесу. Зайдите в кабину пилотов."
                        }
                    },
                    {
                        text: {
                            en: "Pick up the 'Armored Case' located behind the pilot's seat.",
                            tr: "Pilot koltuğunun arkasındaki 'Zırhlı Çanta'yı (Armored Case) al.",
                            ru: "Подберите «Бронированный кейс», находящийся за креслом пилота."
                        },
                        images: ['/Story/FallingSkies/Step6-Case.webp']
                    },
                    {
                        text: {
                            en: "CHOICE A: Give to Prapor -> Unlocks 'Man of His Word' achievement + 1.5M Roubles.",
                            tr: "SEÇİM A: Prapor'a Ver -> 'Sözünün Eri' başarımını açar + 1,5M Ruble.",
                            ru: "ВЫБОР А: Отдать Прапору -> Открывает достижение «Человек слова» + 1,5 млн рублей."
                        }
                    },
                    {
                        text: {
                            en: "CHOICE B: Keep it -> Unlocks 'Just Business' achievement + Case for yourself.",
                            tr: "SEÇİM B: Kendine Sakla -> 'Sadece İş' başarımını açar + Çanta senin olur.",
                            ru: "ВЫБОР Б: Оставить себе -> Открывает достижение «Просто бизнес» + Кейс остаётся у вас."
                        }
                    }
                ]
            }
        }
    ]
};